<form [formGroup]="formYokoten">
  <div class="card m-3">
    <h5 class="card-header">Yokoten <span class="legend-label"></span></h5>
    <!-- {{requiredLegend}} -->
    <div class="card-body">

      <div class="form-group row">
        <label for="yokotenFromOtherShop" class="col-sm-4 col-form-label">Is this yokoten from another shop or
        plant?</label>
        <label class="switch">
          <input type="checkbox" formControlName="isYokoyenFromAnotherShop" id="yokotenFromOtherShop"
            (change)="onYokotenFromOtherShopChange($event)">
            <span class="slider round"></span>
          </label>
          <label for="yokotenFromOtherShop" class="slider-label">{{isYokoyenFromAnotherShopYesNo}}</label>
        </div>
        @if (isyokotenFromOtherShop) {
          <div>
            <div class="form-group row">
              <label for="haveBpaksID" class="col-sm-4 col-form-label">Does the original kaizen have a BPAKS ID?</label>
              <label class="switch">
                <input type="checkbox" formControlName="haveBpaksID" id="haveBpaksID"
                  (change)="haveBpaksIDChange($event)">
                  <span class="slider round"></span>
                </label>
                <label for="haveBpaksID" class="slider-label">{{haveBpaksIDYesNo}}</label>
              </div>
              @if (haveBpaksID) {
                <div>
                  <div class="form-group row">
                    <label for="KaizenSourceIdentifier" class="col-sm-4 col-form-label">BPAKS Kaizen ID  <small class="invalid">*</small></label>
                    <div class="col-sm-6 p-1">
                      <input type="text" formControlName="kaizenSourceIdentifier" class="form-control" (change)="kaizenSourceIdentifierchanged($event)"
                        placeholder="BPAKS kaizen Id">
                        @if (haveBpaksID  && formYokoten.get('kaizenSourceIdentifier')?.errors?.['required'] && formYokoten.get('kaizenSourceIdentifier')?.touched) {
                          <small class="invalid"
                            >BPAKS kaizen
                            Id is required field
                          </small>
                        }
                        @if (haveBpaksID  && formYokoten.get('kaizenSourceIdentifier')?.errors?.['maxlength']) {
                          <small class="invalid"
                            >BPAKS kaizen Id maximum length is 200 characters
                          </small>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (!haveBpaksID) {
                  <div>
                    <div class="form-group row">
                      <label for="kaizenSourceId" class="col-sm-4 col-form-label-textbox-center">Please specify the source *</label>
                      <div class="col-sm-6 p-1">
                        <select class="form-select" formControlName="kaizenSourceId" aria-label="Default select example" (change)="kaizenSourceIdChanged($event)" >
                          <option value="">Select Source</option>
                          @for (kaizenSource of  kaizenSources; track kaizenSource) {
                            <option [value]="kaizenSource.kaizenSourceID">
                            {{kaizenSource.name}}</option>
                          }
                        </select>
                        @if (formYokoten.get('kaizenSourceId')?.errors?.required) {
                          <small class="invalid">Source is required</small>
                        }
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="kaizenSourceDescription" class="col-sm-4 col-form-label">Identifier number or
                      description:</label>
                      <div class="col-sm-6 p-1">
                        <textarea class="form-control" formControlName="kaizenSourceDescription" (change)="kaizenSourceDescriptionChanged($event)"
                          name="kaizenSourceDescription" placeholder="Identifier number or descriptipon" rows="3"
                        class="form-control"></textarea>
                        @if (formYokoten.get('kaizenSourceDescription')?.errors?.['maxlength']) {
                          <small class="invalid"
                            >Identifier number or description maximum length is 2000 characters
                          </small>
                        }
                      </div>
                    </div>
                  </div>
                }
                <div class="form-group row">
                  <label for="additionalKaizenSourceDescription" class="col-sm-4 col-form-label">Additional description or
                  comments:</label>
                  <div class="col-sm-6 p-1">
                    <textarea class="form-control" formControlName="additionalKaizenSourceDescription" (change)="addKaizenSourceDesChanged($event)"
                    name="BriefDescription" placeholder="Brief description" rows="3" class="form-control"></textarea>
                    @if (formYokoten.get('additionalKaizenSourceDescription')?.errors?.['maxlength']) {
                      <small class="invalid"
                        >Additional description or
                        comments maximum length is 2000 characters
                      </small>
                    }
                  </div>
                </div>
              </div>
            }

            @if (!isyokotenFromOtherShop) {
              <div class="form-group row">
                <label for="yokotenToOtherShop" class="col-sm-4 col-form-label">Can this be yokotened to another
                shop?</label>
                <label class="switch">
                  <input type="checkbox" formControlName="yokotenToOtherShop" (change)="yokotenedToOtherShopChange($event)" id="yokotenToOtherShop">
                  <span class="slider round"></span>
                </label>
                <label  for="yokotenToOtherShop" class="slider-label">{{yokotenToOtherShopYesNo}}</label>
              </div>
            }
            @if (yokotenToOtherShops) {
              <div class="form-group row">
                <label for="applicableForSpecificShop" class="col-sm-4 col-form-label">Applicable for only this specific shop?
                  @if ((yokotenToOtherShops && isApplicableForSpecificShop==false && isApplicableAccrossOtherShops == false)) {
                    <small class="invalid"
                    >required</small>
                  }</label>
                  <label class="switch">
                    <input type="checkbox" formControlName="applicableForSpecificShop" id="applicableForSpecificShop"
                      (change)="applicableForSpecifiShopChange($event)">
                      <span class="slider round"></span>
                    </label>
                    <label class="slider-label-side-by-side">{{applicableForSpecificShopYesNo}}</label>
                    <label for="applicableForOtherShop" class="col-sm-4 col-form-label">Applicable across other shops? @if ((yokotenToOtherShops && isApplicableForSpecificShop==false && isApplicableAccrossOtherShops == false)) {
                      <small
                        class="invalid"
                      >required</small>
                    }</label>
                    <label class="switch">
                      <input type="checkbox" formControlName="applicableAccrossOtherShops" id="applicableForOtherShop"
                        (change)="applicableAccrossOtherShopschange($event)">
                        <span class="slider round"></span>
                      </label>
                      <label class="slider-label-side-by-side">{{applicableAccrossOtherShopsYesNo}}</label>
                    </div>
                  }
                  <div class="form-group">
                    <p for="tag1">Please provide any additional tags/keywords that can be used for other users to search
                    this kaizen:</p>
                    <div class="input-group">
                      <input type="text" class="form-control" formControlName="kaizenKeyWord1" placeholder="Keyword 1" (change)="kaizenKeyWordChanged($event)" id="tag1"/>
                      <span class="input-group-addon">&nbsp;</span>
                      <input type="text" class="form-control" formControlName="kaizenKeyWord2" placeholder="Keyword 2"  (change)="kaizenKeyWordChanged($event)" id="tag2"/>
                      <span class="input-group-addon">&nbsp;</span>
                      <input type="text" class="form-control" formControlName="kaizenKeyWord3" placeholder="Keyword 3" (change)="kaizenKeyWordChanged($event)"  id="tag3"/>
                      <span class="input-group-addon">&nbsp;</span>
                      <input type="text" class="form-control" formControlName="kaizenKeyWord4" placeholder="Keyword 4" (change)="kaizenKeyWordChanged($event)" id="tag4" />
                      <span class="input-group-addon">&nbsp;</span>
                      <input type="text" class="form-control" formControlName="kaizenKeyWord5" placeholder="Keyword 5" (change)="kaizenKeyWordChanged($event)" id="tag5" />
                    </div>
                  </div>

                </div>
              </div>
            </form>